import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";

import Background from "../assets/wallet-background.png";
import CommunityDashboard from "../components/CommunityDashboard";
import DrawerDetails from "../components/DrawerDetails";
import MobileTabBar from "../components/MobileTabBar";
import Radium from "radium";
import Ranking from "../components/Ranking";
import SideMenu from "../components/SideMenu";
import SignedIn from "./SignedIn";
import User from "../components/User";
import { useIPFS } from "../hooks/useIPFS";
import { useMoralis } from "react-moralis";
import { useRef } from "react";

const Main = () => {
  const challengesSection = useRef();
  const nftSection = useRef();

  const { Moralis } = useMoralis();
  const { resolveLink } = useIPFS();
  const [tokenList, setTokenList] = useState();

  //useEffect Hook call initial fetch
  useEffect(() => {
    async function fetchData() {
      const tokenList = await fetchNFTsForContract();
      setTokenList(tokenList);
    }
    fetchData();
  }, []);

  //Show nft given by contract address
  const fetchNFTsForContract = async () => {
    const options = {
      address: "0x7dE3085b3190B3a787822Ee16F23be010f5F8686",
      chain: "eth",
      limit: 6,
    };
    const NFTs = await Moralis.Web3API.token.getAllTokenIds(options);
    const result = NFTs.result;
    for (let NFT of result) {
      if (NFT?.metadata) {
        NFT.metadata = JSON.parse(NFT.metadata);
        NFT.image = resolveLink(NFT.metadata?.image);
      } else if (NFT?.token_uri) {
        try {
          await fetch(NFT.token_uri)
            .then((response) => response.json())
            .then((data) => (NFT.image = resolveLink(data.image)));
        } catch (error) {
          console.log(error);
        }
      }
    }
    return result;
  };

  return (
    <div className="main">
      <BrowserRouter>
        {/* &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}

        <div className="main-body">
          <Row>
            <Col xs={0} sm={0} md={5} lg={6} xl={4} xxl={4} style={styles.sideMenu}>
              <SideMenu nftSection={nftSection} challengesSection={challengesSection} />
            </Col>

            <Routes>
              <Route
                path="/"
                element={
                  <SignedIn
                    nftSection={nftSection}
                    challengesSection={challengesSection}
                    tokenList={tokenList}
                  />
                }
              />
              <Route
                path="/community/:id"
                element={
                  <CommunityDashboard
                    nftSection={nftSection}
                    challengesSection={challengesSection}
                    tokenList={tokenList}
                  />
                }
              />
            </Routes>

            <Col style={styles.detailsDiv} xs={0} sm={0} md={0} lg={0} xl={6} xxl={4}>
              <User nftSection={nftSection} />
              <Ranking />
            </Col>

            {/* drawer for tablet version */}
            <div style={styles.drawer}>
              <DrawerDetails
                children={
                  <Col style={styles.drawer.children}>
                    <User nftSection={nftSection} />
                    <Ranking />
                  </Col>
                }
              />
            </div>

            {/* tabbar for mobile version */}
            <div style={styles.mobileTabBar}>
              <MobileTabBar nftSection={nftSection} challengesSection={challengesSection} />
            </div>
          </Row>
        </div>
      </BrowserRouter>
    </div>
  );
};

export default Radium(Main);

const query = {
  xs: "@media (max-width: 576px)",
  sm: "@media (max-width: 767px)",
  md: "@media (max-width: 992px)",
  lg: "@media (max-width: 1200px)",
  xl: "@media (max-width: 1600px)",
  small: "@media (max-width: 600px)",
  medium: "@media (max-width: 1440px)",
  large: "@media (max-width: 1700px)",
};

const styles = {
  sideMenu: {
    justifyContent: "space-between",
    position: "sticky",
    top: 0,
    height: "100vh",
  },
  detailsDiv: {
    backgroundColor: "rgb(120, 213, 4,0.9)",
    backgroundImage: `url(${Background})`,
    backgroundPosition: "20% 0",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    position: "sticky",
    top: 0,
    height: "100vh",
    padding: "16px",
  },

  drawer: {
    display: "none",
    position: "fixed",
    right: "16px",
    zIndex: 1,
    [query.lg]: { display: "block" },
    [query.sm]: { display: "none" },
    children: {
      backgroundColor: "rgb(120, 213, 4,0.9)",
      backgroundImage: `url(${Background})`,
      backgroundPosition: "20% 0",
      backgroundSize: "cover",
      minHeight: "90vh",
      height: "100%",
      maxWidth: "300px",
      width: "100%",
      padding: "16px",
      overflowY: "hidden",
    },
  },
  mobileTabBar: {
    display: "none",
    position: "sticky",
    bottom: 0,
    zIndex: 1,
    width: "100vw",
    [query.sm]: { display: "flex" },
  },
};
